import { Base } from './base';

export class UserDevice extends Base {
  deviceId: string;
  name: string;
}
